import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { NavBar, Footer, SideBar } from './components';
import CustomFormData from './actions/myaxios/CustomFormData';
import { app } from './actions';
class App extends PureComponent {
    componentDidMount() {
        window.FormData = CustomFormData;
    }
    render() {
        const { children, cancelMenus } = this.props;
        return (React.createElement("div", { role: 'button', tabIndex: 0, onClick: cancelMenus, onKeyDown: (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    cancelMenus();
                }
            } },
            React.createElement(NavBar, null),
            window.location.pathname.includes('vault') && React.createElement(SideBar, null),
            React.createElement("div", null, children),
            !window.location.pathname.includes('vault') && React.createElement(Footer, null)));
    }
}
export default connect(null, { ...app })(withRouter(App));
